/**
 * Coordinates "refresh on returning to the foreground".
 *
 * Returning to the app re-fetches lists for freshness, but a quick tab-switch
 * (a short background) should NOT re-fetch already-fresh data. This gate records
 * when the app was backgrounded and reports whether enough time has passed that
 * a foreground refresh is worthwhile — so all foreground-refresh paths (the
 * QueryStore subscribed-query reload and the list warmup) can share one decision.
 */
export const FOREGROUND_STALE_THRESHOLD_MS = 30_000;

export class ForegroundRefreshGate {
	private backgroundedAt: null | number = null;

	public markBackgrounded(): void {
		this.backgroundedAt = Date.now();
	}

	public shouldRefreshAfterForeground(): boolean {
		if (this.backgroundedAt === null) {
			return true;
		}

		return Date.now() - this.backgroundedAt >= FOREGROUND_STALE_THRESHOLD_MS;
	}
}

export const foregroundRefreshGate = new ForegroundRefreshGate();
